import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './config/i18n';

const CHUNK_RETRY_KEY = 'aml_chunk_load_retry';

function handleChunkError(error: unknown) {
  const err = error as { message?: string; name?: string };
  const chunkFailed = /Loading chunk [\d]+ failed/i;

  if (err && (chunkFailed.test(err.message ?? '') || err.name === 'ChunkLoadError')) {
    const retries = parseInt(sessionStorage.getItem(CHUNK_RETRY_KEY) || '0', 10);
    if (retries < 2) {
      sessionStorage.setItem(CHUNK_RETRY_KEY, String(retries + 1));
      window.location.reload();
      return;
    }
    sessionStorage.removeItem(CHUNK_RETRY_KEY);
  }
}

window.addEventListener('unhandledrejection', (event) => {
  handleChunkError(event.reason);
});

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
